import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { RecordsTable } from "dyl-components";

import invoiceActions from 'actions/invoice';

import Header from './InvoicesTabTableHeader';

import QuoteBuilderProvider from "shared/context/QuoteBuilderProvider";
import QuoteBuilderModal from "shared/modals/QuoteBuilderModal";
import InvoiceRow from "shared/InvoiceRow";
import { useState } from "react";

const InvoicesTab = () => {
    const limit = 25;
    const { account_id } = useParams();
    const dispatch = useDispatch();
    const [params] = useSearchParams();
    const [filters, setFilters] = useState({
        billed: params.get('billed')?.split(',') || undefined,
        payment_type: params.get('payment_type')?.split(',') || undefined,
        invoice_status: params.get('invoice_status')?.split(',') || undefined,
    });
    useEffect(() => {
        dispatch(invoiceActions.read(account_id, {
            page: params.get('page') || 1,
            billed: params.get('billed')?.split(',') || undefined,
            payment_type: params.get('payment_type')?.split(',') || undefined,
            invoice_status: params.get('invoice_status')?.split(',') || undefined,
            limit: limit,
        }));
    }, [
        params,
        account_id,
        limit,
        dispatch
    ]);
    useEffect(() => {
        const query = new URLSearchParams(params);

        const { billed, payment_type, invoice_status } = filters;
        if (billed?.length > 0) {
            query.set('billed', billed.join(','));
        } else {
            query.delete('billed');
        }
        if (payment_type?.length > 0) {
            query.set('payment_type', payment_type.join(','));
        } else {
            query.delete('payment_type');
        }
        if (invoice_status?.length > 0) {
            query.set('invoice_status', invoice_status.join(','));  
        } else {
            query.delete('invoice_status');
        }

        const query_string = query.toString();
        navigate(`/account/${account_id}/customer/invoices${query_string ? `?${query_string}` : ''}`,);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    const { isReadinginvoices, invoices, count } = useSelector((state) => ({
        isReadinginvoices: state.invoice.isReadingInvoices,
        invoices: state.invoice.invoices,
        count: state.invoice.invoicesCount
    }));

    const navigate = useNavigate();

    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`/account/${account_id}/customer/invoices${query_string ? `?${query_string}` : ''}`);
    }
    const onFilter = async (_, { name, value }) => {
        setFilters({
            ...filters,
            [name]: value
        });
    }
    const [invoiceBeingModified, setInvoiceBeingModified] = useState(null);
    const onModifyInvoice = (id) => {
        setInvoiceBeingModified(id);
    }
    return (
        <QuoteBuilderProvider refreshAccountInformation={() => {
            dispatch(invoiceActions.read(account_id, {
                page: params.get('page') || 1,
                limit: limit
            }));
        }}>
            <RecordsTable
                tableBodyClassName='InvoicesTable'
                isTableLoading={isReadinginvoices}
                isSearchResultEmpty={false}
                isTableEmpty={count === 0}
                TableHeader={<Header onFilter={onFilter} />}
                TableRows={invoices.map(invoice => (
                    <InvoiceRow key={invoice.invoice_id} account_id={account_id} invoice={{
                        ...invoice,
                        created: invoice.invoice_created,
                        due_on: invoice.invoice_due_on,
                        id: invoice.invoice_id,
                        amount: invoice.billed_amount
                    }} onModify={onModifyInvoice} isModifying={invoiceBeingModified === invoice.invoice_id} isCollapsible />
                ))}
                recordsCount={count}
                activePage={params.get('page') || 1}
                onPageChange={onPageChange}
                emptyListTitle={'No Invoices Added'}
                emptySubtitle=' '
                recordsLimit={limit}
            />
            <QuoteBuilderModal account_id={account_id} />
        </QuoteBuilderProvider>
    );
}

export default InvoicesTab;
